import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { title } from './config';
import { TableBody, TableHeader } from './tableConfig';
import { dataProps } from '../../../../data/enums/Component';
import { PanelStyled } from '../../../common/configuration/index';
import CoverageWrapper from '../coverageTarget/CoverageWrapper';
import withErrorAndLoadingScreen from '../../../../utils/composition/withLoading';
import { UPLOADABLES } from '../../../../data/enums/GraphQL';
import PageHeader from '../../../base/PageHeader';
import { EVENT_OPERATION } from '../../../../data/enums/EventOperation';

const propTypes = {
  data: dataProps.value,
  onIconClick: PropTypes.func,
  breadCrumb: PropTypes.arrayOf(Object),
  onCSVUpload: PropTypes.func,
  onTableBodyClick: PropTypes.func,
  onHandleBrandDialog: PropTypes.func.isRequired,
  handleBrandDialog: PropTypes.func,
};

const defaultProps = {
  breadCrumb: [],
  onIconClick: () => null,
  onCSVUpload: () => null,
  data: dataProps.defaultValue,
  onTableBodyClick: () => null,
  handleBrandDialog: () => null,
};

const View = ({ ...props }) => {
  const { data, breadCrumb, onTableBodyClick, onCSVUpload, onIconClick, handleBrandDialog } = props;

  return (
    <Fragment>
      <div className='section-header'>
        <PanelStyled>
          <PageHeader
            display={{}}
            breadCrumb={breadCrumb}
            config={{
              title,
              create: true,
              download: false,
              filter: false,
              upload: true,
              date: false,
            }}
            handleUploadClick={() => {
              onCSVUpload(UPLOADABLES.BRANDCOVERAGETARGET);
            }}
            handleDownloadClick={() => {}}
            handleCreateClick={() => onIconClick(EVENT_OPERATION.CREATE, {}, handleBrandDialog(EVENT_OPERATION.CREATE))}
          />
        </PanelStyled>
      </div>
      <div className='section-content'>
        <CoverageWrapper>
          <div className='table-wrap'>
            <table>
              <TableHeader />
              <tbody>
                {data.list.map((targetData) => (
                  <TableBody
                    key={targetData.id}
                    data={targetData}
                    onTableBodyClick={onTableBodyClick}
                    onIconClick={onIconClick}
                    handleBrandDialog={handleBrandDialog}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </CoverageWrapper>
      </div>
    </Fragment>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const LoginViewWithErrorAndLoading = withErrorAndLoadingScreen(View);

export default LoginViewWithErrorAndLoading;
